import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { CircularProgress, Grid } from "@mui/material";
import { Card, LinearProgress, TableCell } from "@material-ui/core";
import client from "ApiClient";
import MDTypography from "components/MDTypography";
import { useContext, useEffect, useState } from "react";
import moment from "moment";
import { FeatureFlags } from "context/FeatureFlags";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Subscription from "./subscription";
import Invoices from "./invoices";
import { useNavigate } from "react-router-dom";

/* eslint-disable */
export default function Billing() {
  const [isLoading, setIsLoading] = useState(false);
  const [plan, setPlan] = useState(null);
  const [openSB, setOpenSB] = useState(false);
  const [colorSB, setColorSB] = useState("success");
  const [iconSB, setIconSB] = useState("success");
  const [titleSB, setTitleSB] = useState("Success");
  const [contentSB, setContentSB] = useState("Subscription updated successfully");
  const [openSubscription, setOpenSubscription] = useState(false);
  const handleCloseSubscription = () => setOpenSubscription(false);
  const [openInvoices, setOpenInvoices] = useState(false);
  const handleCloseInvoices = () => setOpenInvoices(false);
  const [openPayment, setOpenPayment] = useState(false);
  const handleClosePayment = () => setOpenPayment(false);
  const { features } = useContext(FeatureFlags);
  const [stripeSubscription, setStripeSubscription] = useState(null);
  const [stripePlan, setStripePlan] = useState(null);
  const navigate = useNavigate();

  const account = JSON.parse(localStorage.getItem("account"));

  const oldRender = TableCell.render;
  TableCell.render = function (...args) {
    const [props, ...otherArgs] = args;
    if (typeof props === "object" && props && "isEmpty" in props) {
      const { isEmpty, ...propsWithoutEmpty } = props;
      return oldRender.apply(this, [propsWithoutEmpty, ...otherArgs]);
    } else {
      return oldRender.apply(this, args);
    }
  };

  const options = {
    method: "GET",
    url: "reports",
  };

  const planInformation = async () => {
    options.url = `dashboard/planInformation`;
    await client
      .request(options)
      .then((response) => {
        setPlan(response);
        getStripeSubscription();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const pause = () => {
    const options = {
      method: "GET",
      url: `users/pauseSubscription`,
      headers: {
        "content-type": "application/json",
      },
    };

    client
      .request(options)
      .then((response) => {
        if (response.indexOf("http") !== -1) window.location.href = response;
        else {
          getInvoice();
          planInformation();
          setOpenSB(true);
          setContentSB("Your subscription has been paused. You can resume it anytime");
        }
      })
      .catch(() => {
        // setErrorSB(true);
      });
  };

  const cancel = () => {
    const options = {
      method: "GET",
      url: `users/cancelSubscription`,
      headers: {
        "content-type": "application/json",
      },
    };

    client
      .request(options)
      .then((response) => {
        setOpenSB(true);
        setContentSB("Your subscription has been cancelled.");
        planInformation();
      })
      .catch(() => {
        // setErrorSB(true);
      });
  };

  const uncancel = () => {
    const options = {
      method: "GET",
      url: `users/uncancelSubscription`,
      headers: {
        "content-type": "application/json",
      },
    };

    client
      .request(options)
      .then((response) => {
        if (response.indexOf("http") !== -1) window.location.href = response;
        else {
          setOpenSB(true);
          setContentSB("Your subscription has been uncancelled.");
          planInformation();
        }
      })
      .catch(() => {
        // setErrorSB(true);
      });
  };

  const getInvoice = () => {
    const options = {
      method: "GET",
      url: `stripe/GetInvoices`,
      headers: {
        "content-type": "application/json",
      },
    };

    client
      .request(options)
      .then((response) => {
        setInvoices(response);
      })
      .catch(() => {
        // setErrorSB(true);
      });
  };

  const getStripeSubscription = async () => {
    options.method = "GET";
    options.url = `users/getStripeSubscriptions?token=${account.user_token}`;
    await client
      .request(options)
      .then((response) => {
        setStripeSubscription(response);
        setStripePlan(response.filter((p) => p.price_id === plan.stripe_price_id)[0]);
      //  console.log(response.filter((p) => p.price_id === plan.stripe_price_id)[0]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updatePayment = () => {
    setIsLoading(true);
    const options = {
      method: "GET",
      url: `users/updatePaymentMethod`,
      headers: {
        "content-type": "application/json",
      },
    };

    client
      .request(options)
      .then((response) => {
        setIsLoading(false);
        if (response.indexOf("http") !== -1) window.location.href = response;
      })
      .catch(() => {
        // setErrorSB(true);
      });
  };

  const getPlanCost = () => {    
    switch (plan.frequency) {
      case "month":
        if (stripePlan?.monthly_discount > 0) {
          return (
            <MDBox display="flex">
              <MDTypography variant="subtitle2" color="text" fontWeight="regular">
                Cost &nbsp;
              </MDTypography>
              <MDTypography
                variant="subtitle2"
                color="text"
                fontWeight="regular"
                style={{
                  textDecoration: "line-through",
                }}
              >
                $ {stripePlan?.monthly / 100}
              </MDTypography>
              <MDTypography variant="subtitle2" color="text" fontWeight="regular">
                &nbsp; - &nbsp; $ {stripePlan?.monthly_discount / 100} /{" "}
                {plan.status == "paused" ? "paused" : "month"}
              </MDTypography>
            </MDBox>
          );
        } else {
          return `Cost $ ${plan?.cost / 100} / ${plan.status == "paused" ? "paused" : "month"}`;
        }
      case "yearly":
        if (stripePlan?.yearly_discount > 0) {
          return (
            <MDBox DISPLAY="flex" flexDirection="row">
              <MDTypography variant="subtitle2" color="text" fontWeight="regular">
                Cost &nbsp;
              </MDTypography>
              <MDTypography
                variant="subtitle2"
                color="text"
                fontWeight="regular"
                style={{
                  textDecoration: "line-through",
                }}
              >
                $ {stripePlan?.yearly / 100}
              </MDTypography>
              <MDTypography variant="subtitle2" color="text" fontWeight="regular">
                &nbsp; - &nbsp; $ {stripePlan?.yearly_discount / 100} /{" "}
                {plan.status == "paused" ? "paused" : "year"}
              </MDTypography>
            </MDBox>
          );
        } else {
          return `Cost $ ${plan?.cost / 100} / ${plan.status == "paused" ? "paused" : "year"}`;
        }
      default:
        return `Cost $ ${plan?.cost / 100}`;
    }
  };

  useEffect(() => {
    getInvoice();
    planInformation();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDSnackbar
        color={colorSB}
        icon={iconSB}
        title={titleSB}
        content={contentSB}
        dateTime={""}
        open={openSB}
        onClose={() => setOpenSB(false)}
        close={() => setOpenSB(false)}
        bgWhite
      />
      <Subscription
        openModal={openSubscription}
        closeModal={handleCloseSubscription}
        plan={plan}
        stripeSubscription={stripeSubscription}
      />
      <MDBox pb={3} pt={2}>
        <Grid container spacing={1}>
          {plan && (
            <Grid item xs={12} md={12} lg={12} p={1} mb={2} style={{ width: "80%" }}>
              <Card>
                <Grid
                  justify="flex-end"
                  pb={2}
                  px={2}
                  pt={2}
                  style={{ width: "100%", textAlign: "right" }}
                >
                  {plan?.status != "pause" && (
                    <MDButton
                      disabled={isLoading}
                      variant="outlined"
                      color="warning"
                      sx={{ marginX: 2 }}
                      onClick={() => pause()}
                    >
                      Pause
                    </MDButton>
                  )}
                  {(plan?.status === "deleted" ||
                    plan?.status === "Unknown" ||
                    plan?.status === "Pending cancellation") && (
                    <MDButton
                      disabled={isLoading}
                      variant="outlined"
                      color="success"
                      onClick={() => uncancel()}
                    >
                      Reactivate subscription
                    </MDButton>
                  )}

                  <MDButton
                    disabled={isLoading}
                    variant="outlined"
                    color="success"
                    sx={{ marginX: 2 }}
                    onClick={() => updatePayment()}
                  >
                    UPDATE PAYMENT DETAILS
                    {isLoading && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: "relative", top: 4 }}
                      />
                    )}
                  </MDButton>
                  <MDButton
                    disabled={isLoading}
                    variant="outlined"
                    color="error"
                    onClick={() => cancel()}
                  >
                    CANCEL SUBSCRIPTION
                  </MDButton>
                </Grid>
                {plan.status === "past_due" && (
                  <MDBox pb={1} px={2} flexdirection="column">
                    <MDTypography variant="subtitle" color="error" fontWeight="medium">
                      LAST PAYMENT WAS UNSUCCESSFUL
                    </MDTypography>
                    <MDTypography variant="body1" color="error" fontWeight="regular">
                      We were unable to charge your last payment. Please update your payment
                      information now to keep your subscription active. Without payment your account
                      may be disabled within a few days.
                    </MDTypography>
                  </MDBox>
                )}
                <MDBox pb={2} px={2} pt={2}>
                  <MDTypography variant="h4" fontWeight="medium" textTransform="capitalize">
                    Subscription plan
                  </MDTypography>
                  {getPlanCost()}
                </MDBox>

                <MDBox pb={2} px={2}>
                  {plan.status === "deleted" ||
                  plan.status === "Unknown" ||
                  plan.status === "Pending cancellation" ? (
                    <MDTypography variant="subtitle" color="error" fontWeight="regular">
                      Your plan will end on {moment(plan.nextBillingDate).format("MMM Do YY")}
                    </MDTypography>
                  ) : (
                    <MDTypography variant="subtitle" color="text" fontWeight="regular">
                      Your plan will renew on {moment(plan.nextBillingDate).format("MMM Do YY")}
                    </MDTypography>
                  )}
                </MDBox>
              </Card>
            </Grid>
          )}
          <Grid item xs={12} md={12} lg={12} p={1} mb={2} style={{ width: "80%" }}>
            <Invoices />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
